const pathUrl = {
    baseUrl:"https://radiopharm.idrblab.cn/api/radiopharm",
    // baseUrl:"http://127.0.0.1:8003/api/radiopharm",
    localUrl:"https://radiopharm.idrblab.cn",
}

export default pathUrl;